import { render, staticRenderFns } from "./Cutoff.vue?vue&type=template&id=6ef634df&scoped=true"
import script from "./Cutoff.vue?vue&type=script&lang=js"
export * from "./Cutoff.vue?vue&type=script&lang=js"
import style0 from "./Cutoff.vue?vue&type=style&index=0&id=6ef634df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef634df",
  null
  
)

export default component.exports